// { LoadingSpinner }.js
import React, { useEffect, useState } from 'react';
import "./loading.css"

const  LoadingSpinner  = ({ state }) => {
  const [isEven, setIsEven] = useState(true);

  useEffect(() => {
    const currentDate = new Date();
    const dayOfMonth = currentDate.getDate();
    setIsEven(dayOfMonth % 2 === 0);
  }, []);
  


  
 
  return (
    <div className='z-3'>
      {state && (
        <div>
          <div className="backdrop">
            <div className="position-fixed top-50 start-50 translate-middle ">
              <div className="loading-spinner-container">
                <div className="loading-spinner display-1 text-light bg-d p-4 rounded">
                  {
                    isEven && (<>
                

                   
                    <div className="spinner-border text-light" role="status" id='spin'>
                    <span className="sr-only">Loading...</span>
                    
                  </div>
                  <p>Loading....</p>     </>)
                  }
                 
                  {
                    !isEven &&
                    <div className="loading" >
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="circle"></div>
                   
                  </div>
                  }
                  
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const MetronomeContainer = () => {
  const renderBatonComponents = () => {
    const batons = [];

    for (let i = 0; i < 36; i++) {
      batons.push(
        <div key={i} className={`baton-${i}`}>
          <div className="metronome">
            <div className="baton"></div>
          </div>
        </div>
      );
    }
    console.log(batons);
    return batons;
  };

  return (
    <div className="z-3">
       <div>
          <div className="backdrop-upload">
            
      {renderBatonComponents()}
      </div>
             
          </div>
        </div>
  
  );
};

export { MetronomeContainer,LoadingSpinner };
